module.exports = __webpack_public_path__ + "img/angular.499374c2.png";